module.exports = __webpack_public_path__ + "img/sign-55.6429bc71.jpg";